import { atomWithStorage } from 'jotai/utils';

// HEV対応仕様 §2.1/§2.3: 計算セットは BEV / HEV 単位で管理する。
// powertrain はセッション全体のモードとして扱い、全 R/L 画面と階層一覧取得（/calcs/<pt>/...・
// /assess/<pt>/...）のスコープに用いる。localStorage に永続し、リロードでも保持する。
export type Powertrain = 'bev' | 'hev';

export const powertrainAtom = atomWithStorage<Powertrain>(
    'powertrain',
    'bev',
    undefined,
    { getOnInit: true },
);
